import { render, staticRenderFns } from "./InputModal.vue?vue&type=template&id=6b5db308&scoped=true&"
import script from "./InputModal.vue?vue&type=script&lang=js&"
export * from "./InputModal.vue?vue&type=script&lang=js&"
import style0 from "./InputModal.vue?vue&type=style&index=0&id=6b5db308&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5db308",
  null
  
)

export default component.exports